import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import WelcomeVideoBlockData from 'app/Models/Content/WelcomeVideoBlockData';
import React, {useEffect, useState} from 'react';
import {useInView} from 'react-intersection-observer';
import PopUp from 'app/Components/Shared/Popup/PopUp';
import {isMobile} from 'react-device-detect';
import {Player, ControlBar} from 'video-react';

const WelcomeVideoBlock = ({data, context}: ComponentProps<WelcomeVideoBlockData>) => {
  const [showPopUp, setShowPopUp] = useState(false);
  const {ref, inView} = useInView({triggerOnce: true});
  const videoUrl = isMobile ? data?.videoLinkMobile?.value : data?.videoLink?.value;

  useEffect(() => {
    const isAlreadyViewed = () => {
      if (window.localStorage)
        return localStorage.getItem('VIDEO_KEY') === data.videoKey.value;
    };

    const setIsAlreadyViewed = () => {
      if (window.localStorage)
        localStorage.setItem('VIDEO_KEY', data.videoKey.value);
    };

    if (!isAlreadyViewed() && inView && videoUrl) {
      setIsAlreadyViewed();
      setShowPopUp(true);
    }
  }, [inView, videoUrl]);

  return (
    <div ref={ref} className='WelcomeVideoBlock'>
      <PopUp className='WelcomeVideoBlock__popup' showPopUp={showPopUp} onClose={() => setShowPopUp(false)}>
        <div className='WelcomeVideoBlock__popup__video'>
          <Player fluid={!isMobile} height='100%' playsInline src={videoUrl}>
            <ControlBar autoHide={false} />
          </Player>
        </div>
      </PopUp>
    </div>
  );
};

export default WelcomeVideoBlock;
